import { ObservableValue } from '@prodcard/core'
import { Ref, UnwrapRef, onUnmounted, ref } from 'vue'

export function refObservableValue<T, Ctx>(value: ObservableValue<T, Ctx>): Ref<UnwrapRef<T>> {
  const valueRef = ref<T>(value.value)

  const subscription = value.subscribe(value => {
    valueRef.value = value as UnwrapRef<T>
  })

  onUnmounted(() => value.unsubscribe(subscription))

  return valueRef
}
